// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"_1198dd19","title":"_9b03bacc","shimmerLoadingBackground":"_66ba1881"};